<template>
  <c-view>
    <c-page class="s-actionsheet">
      <c-navbar :share="canShare"></c-navbar>
      <c-content>
        <c-panel-container>
          <c-panel :img="item.img" :title="item.title" :desc="item.desc" v-for="item in panelItems" :key="item.title">
            <div>
              <h4 class="price" v-html="item.price"></h4>
              <div class="ori-discount" v-html="item.oriPrice"></div>
            </div>
          </c-panel>
        </c-panel-container>
        <c-images :img-items="images"></c-images>
        <!--高级版添加协议-->
        <div class="overlay-text" v-if="Number(resId) === Goods.saas.advanced.id">
          <div class="overlay-mask overlay-mask-one" @click="openLaws">
          </div>
          <div class="overlay-mask overlay-mask-two" @click="goToProtocol">
          </div>
        </div>
      </c-content>
      <c-footer class="footer-shadow">
        <c-button @click.native="buy">
          <div>{{ btnText }}</div>
        </c-button>
      </c-footer>
      <c-action-sheet :visible.sync="actionsheetShow">
        <div class="close-btn" @click="closeActionSheet"><i class="s-icon-times-circle-o"></i></div>
        <div slot="menu">
          <div class="action-wrap">
            <action-modal></action-modal>
          </div>
        </div>
      </c-action-sheet>
    </c-page>
    <c-share :visible.sync="share.shareVisible" :config="share.config"></c-share>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "index";
</style>
<script>
  import VasObj from '../../../model/value-added-service/index'
  import Pay from '../../../model/pay'
  import Goods from '../../../model/goods'
  import debounce from 'lodash.debounce'
  import {wechatBuyShareLink, hybirdMobilePay} from '@/config/net'
  import ActionModal from '../../tabs/2018-05-18/real-sale/action-modal/index.vue'
  import Tickets from '../../../model/tickets/index'
  import api from '../../../tools/api-tools'
  import { mainWeb } from '../../..//config/net'

  export default {
    data () {
      return {
        Goods,
        panelItems: [],
        images: [],
        vasObj: new VasObj(),
        resId: 0,
        pay: new Pay(),
        btnText: '立即购买',
        share: {
          shareVisible: false,
          config: {},
          shareNav: {
            onClick: () => {
              this.share.shareVisible = true
              let data = this.panelItems[0] || {}
              this.share.config = {
                title: data.title,
                link: `${wechatBuyShareLink}/stand-auth.html?saas/${this.resId}`,
                imgUrl: this.panelItems[0].img,
                description: ''
              }
            }
          }
        },
        actionsheetShow: false,
        saasType: 1,
        panelItemInfo: {},
        remarkId: 0
      }
    },
    components: {ActionModal},
    mounted () {
      this.resId = this.$route.params.id
      if (Number(this.resId) === Goods.saas.food.id) { // 餐饮版本添加 PV 统计
        api.get(`${mainWeb}/Function/LogAction.ashx?type=weblog&pid=203`)
      }
      if (this.resId) this.resId = Number.isNaN(this.resId) ? this.resId : Number(this.resId)
      this.vasObj.loadDetail(this.resId).then(res => {
        let {panelItems, images} = res
        this.panelItems = panelItems
        this.images = images
      }).catch(e => {
      })
      this.initGetInfo()
    },
    beforeDestroy () {
    },
    methods: {
      buy: debounce(function () {
        console.log('resId', this.resId)
        if (this.resId === -1) {
          this.$router.push('/hardwareMarket/detail/84')
          return
        }
        if (!this.vasObj.isCanBuy()) {
          let afterAlert = {
            [Goods.saas.mobilePay.id]: () => {
              window.location.href = hybirdMobilePay
            }
          }[this.resId]
          this.$wejs.alert(this.vasObj.getErrorMess(), afterAlert)
          return
        }
        if ([Goods.saas.groupPackage.id, Goods.saas.wxCardAdvanced.id, Goods.saas.msgActivity.id, Goods.saas.smsActivity.id].includes(this.resId)) {
          this.pay.saasPay(this.resId, 1) // 组合支付的数量是1
          return
        }
        if (this.resId === Goods.saas.newRetail.id) {
          this.openActionSheet()
          return
        }
        if (this.resId === Goods.saas.miniApp.id) { // 购买小程序
          this.preConfirm()
          return
        }
        this.pay.saasPay(this.resId, 12)
      }, 220),
      openActionSheet () {
        this.actionsheetShow = true
      },
      closeActionSheet () {
        this.actionsheetShow = false
      },
      initGetInfo () {
        this.vasObj.getUserInfo(this.resId, 0, this.saasType).then(res => {
          this.panelItemInfo.price = res.RealMoney
          this.panelItemInfo.CouponList = (res.CouponList || {}).CouponListModels || []
          this.panelItemInfo.IsShowCommuteIntegral = res.IsShowCommuteIntegral
          this.panelItemInfo.IsShowCoupon = res.IsShowCoupon
          Tickets.SetTicket(Tickets.ConvertCouponListModels(this.panelItemInfo.CouponList))
        })
      },
      preConfirm () {
        this.$store.commit('setOrderConfirmConfig', {
          showAddress: this.remarkId !== 0,
          showRemark: false
        })
        this.$store.commit('setOrderGoodsInfo', {
          goodsId: this.resId,
          remark: 0,
          name: this.panelItems[0].title,
          icon: this.panelItems[0].img,
          price: this.panelItemInfo.price,
          count: 1,
          goodsType: 1,
          isCouponUnAvaliable: !(this.panelItemInfo.CouponList.length > 0 && this.panelItemInfo.IsShowCoupon !== 0),
          isIntegralUnAvaliable: this.panelItemInfo.IsShowCommuteIntegral === 0
        })
        this.$router.push(`/orderConfirm`)
      },
      openLaws () {
        this.$router.push('/user-protocol')
      },
      goToProtocol () {
        this.$router.push('/apple-auto-renew-protocol')
      }
    },
    computed: {
      canShare () {
        return this.resId !== Goods.saas.mobilePay.id ? this.share.shareNav : null
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?73305916